import { getRuntime, pickBool, pickString } from './runtimeConfig'

function getIdleLockRuntime() {
  const rt = getRuntime()
  return rt.idleLock && typeof rt.idleLock === 'object' ? rt.idleLock : {}
}

/** 是否启用空闲全屏锁 */
export function isIdleLockEnabled() {
  const il = getIdleLockRuntime()
  if (il.enabled === true) return true
  if (il.enabled === false) return false
  return pickBool('VUE_APP_IDLE_LOCK_ENABLED', false)
}

/** 解锁密码（未配置时无法通过密码解锁） */
export function getIdleLockPassword() {
  const il = getIdleLockRuntime()
  if (il.password != null && String(il.password) !== '') {
    return String(il.password)
  }
  return pickString('idleLockPassword', 'VUE_APP_IDLE_LOCK_PASSWORD', '')
}

/** 无操作多少秒后上锁，默认 60 */
export function getIdleLockSeconds() {
  const il = getIdleLockRuntime()
  if (il.seconds != null && il.seconds !== '') {
    const n = Number(il.seconds)
    if (!Number.isNaN(n) && n > 0) return n
  }
  const fromEnv = process.env.VUE_APP_IDLE_LOCK_SECONDS
  if (fromEnv !== undefined && fromEnv !== '') {
    const n = Number(fromEnv)
    if (!Number.isNaN(n) && n > 0) return n
  }
  return 60
}

export function getIdleLockTimeoutMs() {
  return getIdleLockSeconds() * 1000
}
